"use strict";

var _taggedTemplateLiteral = require("/root/icatu-frontend/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  position: relative;\n  &:hover {\n    opacity: 0.7;\n  }\n  a {\n    color: inherit;\n    text-decoration: none;\n  }\n  svg {\n    fill: ", ";\n  }\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.navbarItem = void 0;

var _stylitas = require("@creditas/stylitas");

var navbarItem = function navbarItem(_ref) {
  var theme = _ref.theme,
      selected = _ref.selected;
  return (0, _stylitas.css)(_templateObject(), _stylitas.utilities.palette.color(theme, 'neutral01'), selected && "\n    &::before {\n      background: ".concat(_stylitas.utilities.palette.color(theme, 'primary03'), ";\n      bottom: 0;\n      content: '';\n      display: block;\n      height: 4px;\n      position: absolute;\n      width: calc(100% + 20px);\n    }\n\n  "));
};

exports.navbarItem = navbarItem;